<sk-button-group data-test="language-select-button">
  <sk-button
    [suppressMinWidth]="true"
    [label]="'DE'"
    [active]="userLang === 'de'"
    (click)="changeLanguage('de')"
    data-test="language-select-de-button">
  </sk-button>
  <sk-button
    [suppressMinWidth]="true"
    [label]="'EN'"
    [active]="userLang === 'en'"
    (click)="changeLanguage('en')"
    data-test="language-select-en-button">
  </sk-button>
</sk-button-group>
